import BaseFileService from "@/modules/core/file/protected/BaseFileService";
import env from "environment";

class MicroCreditFileService extends BaseFileService {
  constructor() {
    super({
      baseUrl: env.baseUrl + "/micro-credit/files"
    });
  }
}

const service = new MicroCreditFileService();

export default service;
